module.exports = __webpack_public_path__ + "static/media/OpenEnglish.0d1e5263.png";